import {fillLayoutMatrixByLocation} from '../utils';
import type {LayoutMatrix, LayoutLocations, CellId} from '../types';

/**
 * Parses Cells locations and builds a matrix that represents the Layout structure,
 * where each Cell corresponds to the Cell ID located at the corresponding coordinates.
 *
 * Example: 3 by 3 Layout with 9 Cells
 * [
 *   ['item_id_1', 'item_id_2', 'item_id_3'],
 *   ['item_id_4', 'item_id_5', 'item_id_6'],
 *   ['item_id_7', 'item_id_8', 'item_id_9'],
 * ]
 *
 * Example: 3 by 3 Layout with merged Cells
 * [
 *   ['item_id_1', 'item_id_1', 'item_id_2'],
 *   ['item_id_1', 'item_id_1', 'item_id_2'],
 *   ['item_id_3', 'item_id_3', 'item_id_3'],
 * ]
 */
const computeLayoutMatrix = (locations: LayoutLocations): LayoutMatrix => {
  let matrix: LayoutMatrix | Array<Array<CellId>> = [];
  for (const [cellId, location] of Object.entries(locations)) {
    // @ts-expect-error - TS2345 - Argument of type 'CellLocation | undefined' is not assignable to parameter of type 'CellLocation'.
    matrix = fillLayoutMatrixByLocation(matrix, location, cellId);
  }
  return matrix;
};

export default computeLayoutMatrix;
